"use strict";

var Graphics = require('pixi.js').Graphics;
var Sprite = require('pixi.js').Sprite;
const _ = require('lodash');
const SnakeSegment = require('./SnakeSegment.js').SnakeSegment;
const Throttler = require('../util/Throttler.js').Throttler;
const Directions = require('../util/directions.js').Directions;

export let SnakeHead = function(options){
	SnakeSegment.call(this, options);

	// Grab a random direction to start of with
	this.direction = Directions.getRandomDirection();
	this.speed = 0.05;

	if (options.snakeLength > 1) {
		this.addTail(options.snakeLength, this.direction);
	}

	this.moveThrottler = new Throttler(this.speed, () => this.move());

	document.addEventListener('keydown', e => {
		this.changeDirection(e.keyCode);
	});
}

SnakeHead.prototype = Object.create(SnakeSegment.prototype);
SnakeHead.prototype.constructor = SnakeHead;

SnakeHead.prototype.update = function(dt) {
	this.moveThrottler.update(dt);
	SnakeSegment.prototype.update.call(this, dt);
};

SnakeHead.prototype.move = function() {
	const x = this.x + this.direction.x * this.width;
	const y = this.y + this.direction.y * this.height;
	this.setPosition(x, y);
}

SnakeHead.prototype.changeDirection = function(keyCode) {
	const newDirection = Directions.getDirectionFromKeyCode(keyCode);
	if (newDirection !== undefined) {
		this.direction = newDirection
	}
}

SnakeHead.prototype.reverse = function() {
	// Switch last and first segment
	const lastSegment = this.getLastSegment();

	this.visitSegments((segment) => {
		segment.direction = Directions.getOppositeDirection(segment.direction);
	});

	let segment = this;
	while (segment) {
		let save = segment.next;
		segment.next = segment.prev;
		segment.prev = save;
		segment = save;
	}

	SnakeSegment.swapSegment(this, lastSegment);
	this.move();
};

SnakeHead.prototype.createGraphics = function() {
	// draw a shape
	let graphics = new Graphics();
	graphics.lineStyle(1, 0xBBFF33, 0.5);
	graphics.beginFill(0xBBFF33, 1);

	graphics.drawRoundedRect(0, 0, this.width, this.height, this.radius);
	graphics.endFill();
	graphics.x = this.x;
	graphics.y = this.y;
	graphics = new Sprite(graphics.generateTexture(false));
	graphics.anchor.set(0.5, 0.5);
	graphics.scale.set(0, 0);
	return graphics;
};






/** WEBPACK FOOTER **
 ** ./~/jshint-loader!./src/entities/SnakeHead.js
 **/